export enum Languages {
  EN = 'en',
  HU = 'hu',
}
